





































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DateClass from '@/app/module/date'

@Component
export default class PlantList extends Vue {
  @Prop() private data!: any

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    if (num === null || num === undefined) {
      return ''
    }
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  private dateToStringYmd (date: any) {
    if (date === '' || date === null || date === undefined) {
      return '-'
    } else {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }

  private displayIsViewingSestriction (is_viewing_restriction: boolean) {
    if (is_viewing_restriction) {
      return 'あり'
    } else {
      return 'なし'
    }
  }
}

